<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane
        class="paddingBody content"
        :label="$t('Flujos de aprobación de riesgos')"
      >
        <el-row v-if="isAdmin">
          <el-col :span="24" class="right" v-if="!$store.getters.user.readonly">
            <el-button
              size="small"
              type="primary"
              @click="createWorkflow()"
              icon="el-icon-edit"
              v-if="faenas.includes($store.getters.role.faena_id)"
            >{{$t('Nuevo flujo de trabajo')}}</el-button>
          </el-col>
        </el-row>
        <br v-if="!loading"/>
        <center v-if="loading">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px;"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <el-row v-else>
          <el-table
            :max-height="700"
            class="workflowTable"
            :default-sort="{prop: 'nombre'}"
            :data="workflows"
            row-class-name="rowClassTablaPloma"
            cell-class-name="cellClassTablaPloma"
            header-cell-class-name="header-cell-class-table-gray"
          >
            <el-table-column sortable prop="name" :label="$t('Flujo de Aprobación')"></el-table-column>
            <el-table-column width="90px" align="center">
              <template slot-scope="scope">
                <el-button
                  @click="showWorkflow(scope.row)"
                  size="small"
                  icon="el-icon-view"
                  type="info"
                >{{$t('Ver')}}</el-button>
              </template>
            </el-table-column>
            <el-table-column width="140px" align="center" v-if="isAdmin && !$store.getters.user.readonly">
              <template slot-scope="scope">
                <el-button
                  v-if="faenas.includes($store.getters.role.faena_id)"
                  @click="showEditWorkflow(scope.row)"
                  size="small"
                  icon="el-icon-edit-outline"
                  type="primary"
                >{{$t('Modificar')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <ViewWorkflow :visibleSync="dialogViewWorkflow" :onClose="onClose" :workflow="workflow" />

    <EditWorkflow
      :visibleSync="dialogEditWorkflow"
      :onClose="onClose"
      :workflow="workflow"
      :onAcept="getWorkflow"
    />
  </div>
</template>

<script>
import axios from "axios";
import ViewWorkflow from "@/components/workflows/showWorkflow.vue";
import EditWorkflow from "@/components/workflows/EditWorkflow.vue";
import { Circle9 } from "vue-loading-spinner";

export default {
  name: "listWorkflows",
  components: {
    ViewWorkflow,
    EditWorkflow,
    Circle9
  },
  created() {
    this.$store.dispatch(
      "setSubTitle",
      this.$t("Administración de flujos de aprobación")
    );
    this.getWorkflow();
  },
  data() {
    return {
      loading: false,
      workflows: [],
      dialogViewWorkflow: false,
      dialogEditWorkflow: false,
      workflow: {},
      faenas: [
        "5a6f78337b772dcfe68241d5",
        "5a6f78417b772dcfe68241e5",
        "5a6f784e7b772dcfe68241f4",
        "5b48f15d6f0ed90fc02826e3",
        "5bca28914ef25a3fcebd5b2d",
      ],
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.role.admin;
    },
  },
  methods: {
    getWorkflow() {
      this.loading = true;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      axios
        .get("/workflow/", config)
        .then((response) => {
          this.workflows = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    createWorkflow() {
      this.$router.push({ name: "createWorkflow" });
    },
    showWorkflow(workflow) {
      this.workflow = workflow;
      this.dialogViewWorkflow = true;
    },
    showEditWorkflow(workflow) {
      this.workflow = JSON.parse(JSON.stringify(workflow));
      this.dialogEditWorkflow = true;
    },
    onClose() {
      this.idWorkflow = null;
      this.dialogViewWorkflow = false;
      this.dialogEditWorkflow = false;
    },
  },
};
</script>

<style scoped>
.workflowTable {
  max-height: 70vh;
  overflow: auto;
}
.workflow {
  border: solid 1px black;
  border-radius: 5px;
  margin-bottom: 20px;
  margin-right: 10px;
  margin-left: 10px;
  padding: 40px;
  text-align: center;
}
.mt-20 {
  margin-top: 20px;
}
.link {
  color: inherit;
  text-decoration: none;
}
.right {
  text-align: right;
}
.fullHeight {
  min-height: 100vh !important;
}
.cursor {
  cursor: pointer;
}
.content {
  min-height: 50vh;
}
</style>
